import { Currency } from "../Currency.js";
import type { ExchangeRate } from "../ExchangeRatesSetting.js";

export function resolveExchangeRate(currency: Currency, exchangeRates: ExchangeRate[]): number {
	if (currency === Currency.CZK) {
		return 1;
	}
	const exchangeRate = exchangeRates.find((rate) => rate.currency === currency);
	if (!exchangeRate) {
		throw new Error(`No exchange rate found for currency: ${currency}`);
	}
	return exchangeRate.exchangeRate;
}
